import { render, staticRenderFns } from "./EnterpriseInnovationScoreDetail.vue?vue&type=template&id=0c4a4c11&scoped=true&"
import script from "./EnterpriseInnovationScoreDetail.vue?vue&type=script&lang=js&"
export * from "./EnterpriseInnovationScoreDetail.vue?vue&type=script&lang=js&"
import style0 from "./EnterpriseInnovationScoreDetail.vue?vue&type=style&index=0&id=0c4a4c11&lang=scss&scoped=true&"
import style1 from "./EnterpriseInnovationScoreDetail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4a4c11",
  null
  
)

export default component.exports